import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import { EmailFaxLogSearchRequest, EmailFaxLogSearchResult, EmailLogOrderBy, SearchEmailFaxLogItem } from '../../GET_NEW_UI/emailfaxlog/email-fax-log.model';

@Injectable()
export class EmailFaxLogService {

  constructor(private _http: HttpClient) { }

  private handleError(error: Response) {
    console.error(error);
    return Observable.throw(error || 'Server error');
  }

  public getEmailFaxLogs(pageNumber: number, emailLogPageSize: number, SearchItems: SearchEmailFaxLogItem, orderBy: EmailLogOrderBy): Observable<EmailFaxLogSearchResult> {

    const body = new EmailFaxLogSearchRequest(pageNumber, emailLogPageSize, SearchItems, orderBy);
    return this._http.post<EmailFaxLogSearchResult>('api/EmailFaxLog/getEmailFaxLogs', body).pipe(catchError(this.handleError));
  }
}
